// Transitional English translations for legacy transport, CMR, route-planning,
// quotation, e-Transport, temporary-access, and AI interface copy.
//
// This catalog contains interface-owned text only. Business values, company and
// person names, geographic names, identifiers, document content, API enum values,
// and filenames must pass through unchanged. New UI should use semantic i18next
// keys; this compatibility catalog can be removed as those screens are migrated.

export const legacyEnglishTransport = Object.freeze({
  'Unele detalii sunt momentan indisponibile': 'Some details are temporarily unavailable',
  'Detaliile CMR nu sunt disponibile momentan': 'CMR details are temporarily unavailable',
  'Unele detalii nu au putut fi încărcate.': 'Some details could not be loaded.',
  'Serviciul de detalii este temporar indisponibil.': 'The detail service is temporarily unavailable.',
  'Sunt prea multe detalii în așteptare. Reîncercați elementul vizibil.': 'Too many details are waiting. Retry the visible item.',
  // AI document analysis and assistant
  'Te rugăm să introduci instrucțiuni pentru analiză.': 'Please enter analysis instructions.',
  'Rezultatul a fost copiat în clipboard!': 'The result was copied to the clipboard!',
  'Nu s-a putut copia în clipboard.': 'Could not copy the result to the clipboard.',
  'Analiză CMR': 'CMR Analysis',
  'Analiză Fotografii': 'Photo Analysis',
  'Analiză Documente AI': 'AI Document Analysis',
  'Analiză Generală': 'General Analysis',
  'Analiză Rapidă Document': 'Quick Document Analysis',
  'Analizează orice tip de document sau imagine': 'Analyse any type of document or image',
  'Extrage automat informații din documente CMR': 'Automatically extract information from CMR documents',
  'Verificare rapidă și analiză fotografii': 'Quick photo review and analysis',
  'Arată': 'Show',
  'Ambele': 'Both',
  'Analizează Documentele': 'Analyse Documents',
  'Acțiune în așteptare': 'Pending action',
  'Confirmă sau anulează acțiunea propusă de AI': 'Confirm or cancel the action proposed by AI',
  'Disponibil pentru întrebări': 'Ready for questions',
  'Tobi procesează...': 'Tobi is processing...',
  'Întreabă-mă orice despre transporturi, șoferi, documente...': 'Ask me anything about transports, drivers, or documents...',
  'Încarcă un fișier': 'Upload a file',
  'Atașează': 'Attach',
  'Trimite...': 'Sending...',
  'Trimite': 'Send',
  'Share spre colaboratori': 'Share with collaborators',
  'Shift+Enter pentru linie nouă': 'Shift+Enter for a new line',
  'Acceptă imagini și PDF-uri (max 10MB)': 'Accepts images and PDFs (max. 10 MB)',

  // Delivery notes (avize)
  'Editare Aviz': 'Edit Delivery Note',
  'SC Furnizor SRL': 'Example Supplier Ltd',
  'Salvează Draft': 'Save Draft',
  'Finalizează Aviz': 'Finalise Delivery Note',
  'Parțial': 'Partial',
  '+ Creează Aviz Nou': '+ Create New Delivery Note',
  'Creați primul aviz pentru a începe documentarea livrării': 'Create the first delivery note to start documenting the delivery',
  'Furnizor:': 'Supplier:',
  'Document atașat': 'Attached document',
  'Sigur doriți să ștergeți acest aviz?': 'Are you sure you want to delete this delivery note?',
  'Eroare la generarea PDF-ului': 'Error generating the PDF',
  'Descarcă PDF Aviz': 'Download Delivery Note PDF',
  'Creați primul aviz pentru a genera documentele de livrare': 'Create the first delivery note to generate the delivery documents',

  // CMR authoring
  'Nume expeditor / Sender name': 'Sender name',
  'Locație / Location': 'Location',
  'Completează documentul de transport rutier': 'Complete the road consignment document',
  'Câmpuri obligatorii:': 'Required fields:',
  'Nume Expeditor, Nume Destinatar, Loc Livrare': 'Sender Name, Consignee Name, Delivery Location',
  'Câmpurile marcate sunt obligatorii': 'Marked fields are required',
  'Generează PDF': 'Generate PDF',
  'EXPEDITOR': 'SENDER',
  'ADRESĂ': 'ADDRESS',
  'ȚARĂ': 'COUNTRY',
  'DATA ÎNCĂRCARE': 'PICK-UP DATE',
  'RUTĂ': 'ROUTE',
  'MĂRCI/NUMERE': 'MARKS/NUMBERS',
  'NUMĂR COLETE': 'NUMBER OF PACKAGES',
  'NATURA MĂRFII': 'NATURE OF GOODS',
  'DESCRIERE MĂRFURI': 'DESCRIPTION OF GOODS',
  'GREUTATE BRUTĂ (kg)': 'GROSS WEIGHT (kg)',
  'INSTRUCȚIUNI EXPEDITOR': 'SENDER INSTRUCTIONS',
  'INSTRUCȚIUNI DECLARAȚII': 'DECLARATION INSTRUCTIONS',
  'INSTRUCȚIUNI VAMALE': 'CUSTOMS INSTRUCTIONS',
  'CONVENȚII SPECIALE': 'SPECIAL AGREEMENTS',
  'METODĂ PLATĂ': 'PAYMENT METHOD',
  'PREȚ TRANSPORT': 'TRANSPORT PRICE',
  'LOCAȚIE': 'LOCATION',
  'DATA ÎNCHEIERE': 'COMPLETION DATE',
  'NUMĂR CMR': 'CMR NUMBER',
  'REZERVE OBSERVAȚII': 'RESERVATIONS / REMARKS',
  'PRESCRIPȚII FRANCARE': 'POSTAGE INSTRUCTIONS',
  'Actualizează CMR': 'Update CMR',
  'Expeditor': 'Sender',
  'expeditor': 'sender',
  'Data încărcare': 'Pick-up date',
  'Editare CMR': 'Edit CMR',

  // CMR management and electronic signatures
  'Lipsă CMR': 'Missing CMR',
  'Detalii Semnături': 'Signature Details',
  'cerere de semnătură': 'signature request',
  'cereri de semnătură': 'signature requests',
  'Toate datele CMR digital': 'All digital CMR data',
  'Cerere #': 'Request #',
  'Se încarcă semnatarii...': 'Loading signatories...',
  'Are atât CMR digital cât și fizic': 'Has both a digital and a physical CMR',
  '❌ Lipsă': '❌ Missing',
  'Nu există fișier selectat': 'No file selected',
  'Trebuie să adaugi cel puțin un semnatar': 'You must add at least one signatory',
  'Pasul 1: Alege documentul pentru semnare': 'Step 1: Choose the document to sign',
  'Se selectează...': 'Selecting...',
  'Folosește': 'Use',
  'Glisează fișierul PDF aici': 'Drag the PDF file here',
  'Se salvează în transport...': 'Saving to the transport...',
  'Nu am putut trimite cererea de semnare.': 'Could not send the signature request.',
  'Trimite pentru Semnare': 'Send for Signature',
  'Respins': 'Rejected',
  'Sigur dorești să ștergi această cerere de semnătură?': 'Are you sure you want to delete this signature request?',
  'Dorești să forțezi salvarea documentului semnat în S3?': 'Do you want to force-save the signed document to S3?',
  'Ascunde detalii': 'Hide details',
  'ID Cerere:': 'Request ID:',
  'Ultima actualizare:': 'Last updated:',
  'Salvare Manuală': 'Save Manually',
  '⚠️ Salvare Automată Eșuată': '⚠️ Automatic Save Failed',
  'Documentul a fost semnat dar salvarea automată a eșuat. Folosește butonul "Salvare Manuală" pentru a încerca din nou.': 'The document was signed, but automatic saving failed. Use the "Save Manually" button to try again.',
  '❌ Document Respins': '❌ Document Rejected',
  'Un semnatar a respins documentul. Verifică detaliile și creează o nouă cerere dacă este necesar.': 'A signatory rejected the document. Review the details and create a new request if necessary.',
  'Copiază link semnare': 'Copy signing link',
  'Tip fișier invalid! Folosește doar imagini (JPEG, PNG, GIF, WebP) sau PDF.': 'Invalid file type. Use only images (JPEG, PNG, GIF, WebP) or PDF files.',
  'Fișier prea mare! Maxim 10MB.': 'The file is too large. Maximum size: 10 MB.',
  'Eroare la încărcarea fișierului': 'Error uploading the file',
  'Încarcă CMR Fizic (Scanat)': 'Upload Physical CMR (Scanned)',
  'Fișiere acceptate: Imagini (JPEG, PNG, GIF, WebP) sau PDF. Mărime maximă: 10MB.': 'Accepted files: images (JPEG, PNG, GIF, WebP) or PDF. Maximum size: 10 MB.',
  'CMR fizic încărcat cu succes!': 'Physical CMR uploaded successfully!',
  'Click pentru a selecta fișier': 'Click to select a file',
  'sau trage și plasează aici': 'or drag and drop it here',
  'Titlu document (opțional)': 'Document title (optional)',
  'Încarcă CMR': 'Upload CMR',
  'Nu am găsit ID-ul transportului pentru acest CMR': 'Could not find the transport ID for this CMR',
  'cerere': 'request',
  'cereri': 'requests',
  'Gestionare CMR-uri': 'CMR Management',
  'CMR găsit': 'CMR found',
  'CMR-uri găsite': 'CMRs found',
  'Parțial complete (51-99%)': 'Partially complete (51–99%)',
  'Data încărcare de la': 'Pick-up date from',
  'Data încărcare până la': 'Pick-up date to',
  'Nu există CMR-uri': 'No CMRs',
  'Nu au fost găsite CMR-uri care să corespundă criteriilor de căutare.': 'No CMRs match the search criteria.',
  'Nu au fost găsite CMR-uri în sistem.': 'No CMRs were found in the system.',

  // External CMR viewer
  'Secțiunea 1 · Expeditor': 'Section 1 · Sender',
  'Datele companiei care trimite marfa.': 'Details of the company sending the goods.',
  'Nume / firmă': 'Name / company',
  'Secțiunea 2 · Destinatar': 'Section 2 · Consignee',
  'Secțiunea 3-4 · Locații': 'Sections 3–4 · Locations',
  'Locații de încărcare și livrare.': 'Pick-up and delivery locations.',
  'Localitate încărcare': 'Pick-up locality',
  'Țară încărcare': 'Pick-up country',
  'Țară livrare': 'Delivery country',
  'Data livrării': 'Delivery date',
  'Secțiunea 6-12 · Marfă': 'Sections 6–12 · Goods',
  'Detaliile mărfii transportate.': 'Details of the goods being transported.',
  'Mărci și numere': 'Marks and numbers',
  'Număr statistic': 'Statistical number',
  'Greutate brută (kg)': 'Gross weight (kg)',
  'Secțiunea 5 & 13-15 · Instrucțiuni și documente': 'Sections 5 & 13–15 · Instructions and Documents',
  'Documente anexate și instrucțiuni speciale.': 'Attached documents and special instructions.',
  'Număr UIT': 'UIT number',
  'Secțiunea 16 · Transportator': 'Section 16 · Carrier',
  'Marcă autovehicul': 'Vehicle make',
  'Număr circulație': 'Registration number',
  'Secțiunea 17-19 · Observații': 'Sections 17–19 · Remarks',
  'Observații suplimentare și convenții.': 'Additional remarks and agreements.',
  'Rezerve / observații': 'Reservations / remarks',
  'Secțiunea 20 · Plăți': 'Section 20 · Payments',
  'Structura costurilor și a plăților.': 'Cost and payment breakdown.',
  'Total de plată': 'Total payable',
  'Secțiunea 21-22 · Finalizare': 'Sections 21–22 · Completion',
  'Data încheierii': 'Completion date',
  'Nu există documente disponibile.': 'No documents are available.',
  'Disponibil pentru vizualizare': 'Available to view',
  'Codul temporar a expirat': 'The temporary code has expired',
  'în curs...': 'in progress...',
  'activă': 'active',
  'Ultima salvare:': 'Last saved:',
  'CMR actualizat cu succes': 'CMR updated successfully',
  'Modificările au fost resetate': 'Changes reset',
  'Eroare la descărcarea PDF-ului': 'Error downloading the PDF',
  'Eroare la vizualizarea PDF-ului': 'Error displaying the PDF',
  'Actualizat la': 'Updated at',
  'Marfa dumneavoastră a fost livrată cu succes la destinație. Apreciem încrederea acordată și așteptăm cu nerăbdare să vă servim din nou în viitor.': 'Your goods were delivered successfully to their destination. We appreciate your trust and look forward to serving you again.',
  'Marfa a fost livrată cu succes. Vă mulțumim pentru colaborarea excelentă și pentru promptitudinea în procesul de recepție.': 'The goods were delivered successfully. Thank you for your excellent cooperation and prompt receipt.',
  'Apreciem încrederea acordată și profesionalismul dumneavoastră pe parcursul acestui transport. Așteptăm cu nerăbdare să colaborăm din nou în viitor.': 'We appreciate your trust and professionalism throughout this transport. We look forward to working with you again.',
  'Marfă generală': 'General goods',
  'Semnează documentul': 'Sign the document',
  'Se reîncarcă...': 'Reloading...',
  'Cereri de semnare': 'Signature requests',
  'Cerere': 'Request',
  'fără ID': 'without an ID',
  'Detalii compacte expeditor / destinatar': 'Compact sender / consignee details',
  'CMR-ul semnat nu este disponibil încă. Va apărea aici după finalizarea semnăturilor.': 'The signed CMR is not available yet. It will appear here once all signatures are complete.',
  'Nu există documente CMR fizice atașate.': 'No physical CMR documents are attached.',
  'Resetează modificările': 'Reset changes',

  // Route search and PTV optimisation
  'Vezi pe hartă': 'View on map',
  'Șterge punct': 'Delete point',
  'Niciun punct adăugat': 'No points added',
  'Caută și adaugă puncte pe hartă pentru rută': 'Search for and add route points on the map',
  'Eroare la încărcarea hărții': 'Error loading the map',
  'Verifică configurarea API Key-ului Google Maps și conexiunea la internet.': 'Check the Google Maps API key configuration and your internet connection.',
  'Caută o locație...': 'Search for a location...',
  'Prea multe căutări. Încearcă din nou în câteva momente.': 'Too many searches. Please try again in a few moments.',
  'Accesul la serviciul de căutare a fost refuzat.': 'Access to the search service was denied.',
  'Serviciul de locații nu este disponibil': 'The location service is unavailable',
  'Nu s-au găsit coordonatele pentru această locație': 'No coordinates were found for this location',
  'Eroare la procesarea locației selectate': 'Error processing the selected location',
  'Nu s-au putut obține detaliile locației': 'Could not retrieve the location details',
  'Se caută...': 'Searching...',
  'Se încarcă harta...': 'Loading the map...',
  'Configurare Vehicul și Costuri': 'Vehicle and Cost Configuration',
  'Capacitate (kg)': 'Capacity (kg)',
  'Ora Sfârșit': 'End Time',
  'Costuri Operaționale': 'Operating Costs',
  'Cost pe oră (RON)': 'Cost per hour (RON)',
  'Puncte de Start și Sfârșit': 'Start and End Points',
  'Locația de Start (Lat, Lng)': 'Start Location (Lat, Lng)',
  'Locația de Sfârșit (Lat, Lng)': 'End Location (Lat, Lng)',
  'Toate punctele adăugate vor fi tratate ca puncte de livrare (DELIVERY) cu timp de servire de 15 minute.': 'All added points will be treated as delivery points (DELIVERY) with a service time of 15 minutes.',
  'Adaugă cel puțin un punct de livrare pentru a începe optimizarea.': 'Add at least one delivery point to start optimisation.',
  'Optimizare Rută PTV': 'PTV Route Optimisation',
  'Configurează': 'Configure',
  'Începe Optimizarea': 'Start Optimisation',
  'Oprește': 'Stop',
  'Optimizare Nouă': 'New Optimisation',
  'Optimizare Completată': 'Optimisation Complete',
  'Aplică Ruta pe Hartă': 'Apply Route to Map',
  'Eroare la optimizare': 'Optimisation error',
  'Optimizare Completă': 'Optimisation Complete',
  'Ruta optimizată a fost calculată cu succes': 'The optimised route was calculated successfully',
  'Ordine Optimizată': 'Optimised Order',
  'Aplică Ruta': 'Apply Route',
  'În procesare...': 'Processing...',
  'Optimizarea rutei este în desfășurare': 'Route optimisation is in progress',
  'Cererea de optimizare este în coadă': 'The optimisation request is queued',
  'Eșuat': 'Failed',
  'Optimizarea a întâmpinat o problemă': 'The optimisation encountered a problem',
  'Optimizarea a fost oprită': 'The optimisation was stopped',
  'Actualizare în timp real': 'Real-time updates',
  'Traseu (polyline)': 'Route (polyline)',
  'Secțiuni taxe': 'Toll sections',
  'Etape rută': 'Route legs',
  'Instrucțiuni navigare': 'Navigation instructions',
  'Treceri frontieră': 'Border crossings',
  'Încălcări restricții': 'Restriction violations',
  'ID rută': 'Route ID',
  'Locul de unde se ridică marfa - 10 min': 'Goods pick-up location – 10 min',
  'Locul unde se livrează marfa - 15 min': 'Goods delivery location – 15 min',
  '📍 Adaugă Locații Transport': '📍 Add Transport Locations',
  'Se încarcă serviciul de căutare...': 'Loading the search service...',
  'Adresă nedisponibilă': 'Address unavailable',
  'Încearcă o căutare mai specifică': 'Try a more specific search',
  'Căutare disponibilă în toată Europa': 'Search is available across Europe',
  'API se încarcă...': 'Loading API...',
  'punct adăugat': 'point added',
  'puncte adăugate': 'points added',
  'Detalii Parametri Vehicul': 'Vehicle Parameter Details',

  // CMR review actions
  'Editează CMR': 'Edit CMR',
  'Descarcă și salvează PDF': 'Download and Save PDF',
  'Editează mail expeditor': 'Edit sender email',
  'Setează mail expeditor': 'Set sender email',
  'Editează mail destinatar': 'Edit consignee email',
  'Setează mail destinatar': 'Set consignee email',
  'Cod expeditor (email lipsă)': 'Sender code (email missing)',
  'Trimite cod expeditor': 'Send sender code',
  'Cod destinatar (email lipsă)': 'Consignee code (email missing)',
  'Trimite cod destinatar': 'Send consignee code',
  'Pregătesc PDF...': 'Preparing PDF...',
  'Semnătură Electronică': 'Electronic Signature',
  'Email Expeditor:': 'Sender Email:',
  'Route / Rută:': 'Route:',
  'Vehicle / Vehicul:': 'Vehicle:',
  'Declarations instructions / Instrucțiuni declarații:': 'Declaration instructions:',
  'Customs instructions / Instrucțiuni vamale:': 'Customs instructions:',
  'Payment method / Metodă plată:': 'Payment method:',
  'Digital signature / Semnătură digitală': 'Digital signature',
  'Vă rugăm să introduceți o adresă de email.': 'Please enter an email address.',
  'Vă rugăm să introduceți o adresă de email validă.': 'Please enter a valid email address.',
  'nu este setat sau nu este valid. Vă rugăm să introduceți o adresă de email validă.': 'is not set or is invalid. Please enter a valid email address.',

  // Transport documents, cards, crew and stops
  'Termodiagramă': 'Temperature chart',
  'Aviz de însoțire a mărfii': 'Goods delivery note',
  'Declarație vamală': 'Customs declaration',
  'Listă de încărcare': 'Loading list',
  'Documente ADR (mărfuri periculoase)': 'ADR documents (dangerous goods)',
  'Adaugă document transport': 'Add transport document',
  'Categorie: CMR': 'Category: CMR',
  'Poza CMR anterioară': 'Previous CMR image',
  'Poza CMR următoare': 'Next CMR image',
  'Previzualizare indisponibilă pentru acest tip de fișier': 'Preview unavailable for this file type',
  'Descarcă fișierul': 'Download file',
  'Statistici Șoferi': 'Driver Statistics',
  'Șoferi Activi': 'Active Drivers',
  'Șoferi cu transporturi atribuite': 'Drivers with assigned transports',
  'Transporturi Atribuite': 'Assigned Transports',
  'Transporturi care au șoferi alocați': 'Transports with assigned drivers',
  'Șoferi în Traseu': 'Drivers En Route',
  'Șoferi care au început cursa': 'Drivers who have started their trip',
  'Sincronizarea AROBS a fost programată și rulează în fundal.': 'AROBS synchronisation has been scheduled and is running in the background.',
  'Km și consumul AROBS au fost sincronizate.': 'AROBS mileage and fuel consumption have been synchronised.',
  'Nu au fost făcute modificări.': 'No changes were made.',
  'Eroare la salvarea transportului.': 'Error saving the transport.',
  'Mod transport și echipaj': 'Transport and crew mode',
  'Șofer transport': 'Transport driver',
  'Echipajul a fost actualizat.': 'The crew has been updated.',
  'Selectează camion': 'Select a truck',
  'Din flotă': 'From the fleet',
  'Externă': 'External',
  'Selectează remorcă': 'Select a trailer',
  'Email Expeditor': 'Sender Email',
  'expeditor@email.com': 'sender@example.com',
  'Opririle deja începute sau finalizate sunt blocate. Data și ora sunt obligatorii pentru acest transport.': 'Stops already started or completed are locked. A date and time are required for this transport.',
  'Opririle deja începute sau finalizate sunt blocate. Datele planificate sunt opționale pentru acest transport.': 'Stops already started or completed are locked. Planned dates are optional for this transport.',
  'Sincronizare în curs...': 'Synchronising...',
  'Preț net': 'Net price',
  'Diurnă override': 'Per diem override',
  'Profitabilitatea este activă pentru acest transport internațional cu flotă proprie; completează punctele în ordine.': 'Profitability is enabled for this international transport using the company fleet; enter the points in order.',
  'Poți adăuga punctele de trecere în ordine, dar ele nu sunt obligatorii pentru acest transport.': 'You can add transit points in order, but they are optional for this transport.',
  '✅ Document generat și salvat cu succes în documentele transportului.': '✅ Document generated and saved successfully with the transport documents.',
  'Eroare la generarea documentului.': 'Error generating the document.',
  'Generează document pentru transport #': 'Generate document for transport #',
  'Completează detaliile și documentul va fi generat automat și salvat ca PDF.': 'Complete the details and the document will be generated automatically and saved as a PDF.',
  'Destinatar (opțional)': 'Consignee (optional)',
  'Document de predare-primire marfă': 'Goods handover document',
  'Observații (opțional)': 'Remarks (optional)',
  'Ex: Marfă în stare bună': 'E.g. goods in good condition',
  'Martor (opțional)': 'Witness (optional)',
  'Generează și salvează PDF': 'Generate and Save PDF',
  '✅ Foaia de parcurs a fost generată și descărcată.': '✅ The trip sheet was generated and downloaded.',
  'Nu am putut încărca componentele de grupaj.': 'Could not load the consolidated-load items.',
  'Completează clientul, prețul și metri podea.': 'Enter the customer, price, and loading metres.',
  'Componenta de grupaj a fost actualizată.': 'The consolidated-load item has been updated.',
  'Componenta de grupaj a fost adăugată.': 'The consolidated-load item has been added.',
  'Nu am putut salva componenta de grupaj. Verifică datele și încearcă din nou.': 'Could not save the consolidated-load item. Check the details and try again.',
  'Componenta de grupaj a fost stearsa.': 'The consolidated-load item has been deleted.',
  'Nu am putut șterge componenta de grupaj. Încearcă din nou.': 'Could not delete the consolidated-load item. Please try again.',
  'Reincarca': 'Reload',
  'Incarcare': 'Loading',
  'Nu exista componente de grupaj pentru acest transport.': 'There are no consolidated-load items for this transport.',
  'Editeaza componenta': 'Edit item',
  'Preț *': 'Price *',
  'Monedă *': 'Currency *',
  'Salveaza componenta': 'Save item',
  'Se încarcă documentele semnate...': 'Loading signed documents...',
  'După finalizarea semnării, documentele vor apărea aici.': 'Documents will appear here once signing is complete.',
  '· Comandă client': '· Customer order',
  'Se încarcă locațiile...': 'Loading locations...',
  'Estimare Întârziere': 'Estimated Delay',
  'Status Șofer': 'Driver Status',
  'Informații Șofer': 'Driver Information',
  'Respinse': 'Rejected',
  'Trimite la semnat': 'Send for signature',
  'Status de la șofer': 'Driver status',
  'Marcajele sunt independente de eCMR și se salvează pe transport.': 'These markers are independent of eCMR and are saved on the transport.',
  'Confirmă manual că documentele transportului au fost expediate.': 'Manually confirm that the transport documents have been sent.',
  'Factură emisă': 'Invoice issued',
  'Confirmă manual că factura transportului a fost emisă.': 'Manually confirm that the transport invoice has been issued.',
  'Schimbarea la Solo îl va elimina pe Șoferul 2. Continui?': 'Switching to Solo will remove Driver 2. Continue?',
  'Modul transportului nu mai poate fi schimbat după pornire.': 'The transport mode cannot be changed after it has started.',
  'Echipaj incomplet — transportul poate fi salvat și completat ulterior.': 'Incomplete crew — the transport can be saved and completed later.',
  'Transportul poate fi salvat fără șofer.': 'The transport can be saved without a driver.',
  'Ordinea selectată stabilește Șoferul 1 și Șoferul 2.': 'The selected order determines Driver 1 and Driver 2.',
  'Șoferul selectat va fi atribuit transportului.': 'The selected driver will be assigned to the transport.',
  'Se încarcă istoricul echipajului…': 'Loading crew history…',
  'Nu există modificări de echipaj.': 'There are no crew changes.',
  'Șoferul 1': 'Driver 1',
  'Șoferul 2': 'Driver 2',
  'Echipajul existent este read-only deoarece funcția nu este activă pentru acest cont.': 'The existing crew is read-only because this feature is not enabled for this account.',
  'Motivul înlocuirii este obligatoriu.': 'A reason for the replacement is required.',
  'Echipajul a fost schimbat între timp. Am încărcat rosterul curent; verifică și confirmă din nou.': 'The crew has changed in the meantime. We loaded the current roster; review it and confirm again.',
  'Fără șoferi': 'No drivers',
  'Înlocuiește': 'Replace',
  'Înlocuiește echipajul': 'Replace crew',
  'Rosterul inițial rămâne baza controlului de concurență până la trimitere.': 'The initial roster remains the concurrency-control baseline until submission.',
  'Salvează echipajul': 'Save crew',

  // Transport details, queue and status
  'În curs verificare': 'Under review',
  'Nu am găsit URL pentru CMR-ul semnat.': 'Could not find a URL for the signed CMR.',
  'Eroare la deschiderea CMR-ului semnat.': 'Error opening the signed CMR.',
  'Detalii CMR': 'CMR Details',
  'Traseu Transport': 'Transport Route',
  'Estimat: 5 zile': 'Estimated: 5 days',
  'Reîncarcă status': 'Reload status',
  'Neîncepută': 'Not started',
  'Creează cod UIT': 'Create UIT code',
  'Trimite la Semnat': 'Send for Signature',
  'Eroare la încărcarea documentelor.': 'Error loading documents.',
  '✅ Document șters cu succes!': '✅ Document deleted successfully!',
  'Eroare la ștergerea documentului.': 'Error deleting the document.',
  'Nu există documente încărcate pentru acest transport.': 'No documents have been uploaded for this transport.',
  'Destinație:': 'Destination:',
  'Început:': 'Start:',
  'Neînceput': 'Not started',
  'Se încarcă coada de transporturi...': 'Loading the transport queue...',
  'Coada de Transporturi': 'Transport Queue',
  'Salvează Ordinea': 'Save Order',
  'Coada este Goală': 'The Queue Is Empty',
  'Acest șofer nu are încă transporturi în coadă.': 'This driver does not have any transports in the queue yet.',
  'Gestionarea Cozii de Transporturi': 'Transport Queue Management',
  'Trageți și plasați transporturile pentru a le reordona. Șoferul va executa transporturile în această ordine, de sus în jos.': 'Drag and drop transports to reorder them. The driver will complete them in this order, from top to bottom.',
  '• Aveți modificări nesalvate. Faceți clic pe "Salvează Ordinea" pentru a le aplica.': '• You have unsaved changes. Click "Save Order" to apply them.',
  'Expeditor:': 'Sender:',
  'Se detectează...': 'Detecting...',
  'Ex: poarta 3, sunați cu 30 min înainte': 'E.g. gate 3, call 30 minutes in advance',
  'Șterge data planificată': 'Clear planned date',
  'Ordinea opririlor este ordinea reală a traseului.': 'The stop order is the actual route order.',
  'Completează locația opririi.': 'Enter the stop location.',
  'Completează data și ora planificată a opririi.': 'Enter the stop’s planned date and time.',
  'Completează noua oprire în formularul de mai jos; după salvare o poți reordona.': 'Enter the new stop in the form below; you can reorder it after saving.',
  'Corectează tipul': 'Correct the type',
  'Nu există opriri configurate.': 'No stops are configured.',
  'Adaugă oprire': 'Add stop',
  'Datele transportului au fost salvate în sistem': 'The transport details have been saved in the system',
  'Puteți completa documentul CMR acum sau mai târziu': 'You can complete the CMR document now or later',
  'Clientul, transportatorul și valorile comerciale au fost salvate atomic.': 'The customer, carrier, and commercial values were saved atomically.',
  'Mai Târziu': 'Later',
  'Fotografia nu a putut fi încărcată': 'The photo could not be loaded',
  'Fotografie indisponibilă': 'Photo unavailable',

  // e-Transport classifications and workflow. Stable API values remain untouched.
  'Achiziție intracomunitară': 'Intra-Community acquisition',
  'Operațiuni în sistem lohn (UE) - intrare': 'Inward processing operations (EU) – inbound',
  'Stocuri la dispoziția clientului (Call-off stock) - intrare': 'Call-off stock – inbound',
  'Livrare intracomunitară': 'Intra-Community supply',
  'Operațiuni în sistem lohn (UE) - ieșire': 'Inward processing operations (EU) – outbound',
  'Stocuri la dispoziția clientului (Call-off stock) - ieșire': 'Call-off stock – outbound',
  'Transport pe teritoriul național': 'Transport within the national territory',
  'Tranzacție intracomunitară (intrare pentru depozitare)': 'Intra-Community transaction (inbound for storage)',
  'Tranzacție intracomunitară (ieșire după depozitare)': 'Intra-Community transaction (outbound after storage)',
  'Producție': 'Production',
  'Gratuități': 'Free-of-charge goods',
  'Transfer între gestiuni': 'Transfer between inventories',
  'Bunuri puse la dispoziția clientului': 'Goods made available to the customer',
  'Leasing operațional/financiar': 'Operating/finance lease',
  'Bunuri în garanție': 'Goods under warranty',
  'Operațiuni scutite': 'Exempt operations',
  'Investiție în curs': 'Investment in progress',
  'Donații / ajutoare': 'Donations / aid',
  'Același cu operațiunea': 'Same as the operation',
  'Bucată': 'Piece',
  'Tonă': 'Tonne',
  'Factura': 'Invoice',
  'Eroare la trimiterea către e-Transport.': 'Error submitting to e-Transport.',
  'Acest transport nu are încă ID de încărcare e-Transport salvat.': 'This transport does not yet have a saved e-Transport upload ID.',
  'Nu am putut verifica statusul UIT.': 'Could not check the UIT status.',
  'Loc start traseu rutier': 'Road route start location',
  'Loc final traseu rutier': 'Road route end location',
  'Verifică status UIT': 'Check UIT Status',
  'Trimite și generează UIT': 'Submit and Generate UIT',

  // Transport creation
  'CZK - Coroană cehă': 'CZK – Czech koruna',
  'DKK - Coroană daneză': 'DKK – Danish krone',
  'RON - Leu românesc': 'RON – Romanian leu',
  'SEK - Coroană suedeză': 'SEK – Swedish krona',
  'Național': 'Domestic',
  'Încărcarea și descărcarea au loc în România. Nu sunt necesare vămi.': 'Pick-up and delivery take place in Romania. No customs formalities are required.',
  'Internațional': 'International',
  'Transportul trece granița. Traseul vamal devine obligatoriu doar când se aplică regula de profitabilitate.': 'The transport crosses a border. The customs route is required only when the profitability rule applies.',
  'Atribui șoferul, camionul și remorca din flotă.': 'Assign a driver, truck, and trailer from the fleet.',
  'Comanda este executată de un transportator subcontractat.': 'The order is fulfilled by a subcontracted carrier.',
  'Completeaza doar partea comerciala. Opririle raman la sectiunea de stops, in ordinea traseului.': 'Complete only the commercial details. Stops remain in the Stops section, in route order.',
  'Moneda': 'Currency',
  'Încarcă cel puțin un aviz PDF, Word sau poză standard pentru a continua.': 'Upload at least one delivery note as a PDF, Word document, or standard image to continue.',
  'Documentul DOCX va fi atașat. Detectarea automată a datelor este disponibilă pentru PDF, DOC și imagini.': 'The DOCX file will be attached. Automatic data extraction is available for PDF, DOC, and image files.',
  'Documentele DOCX vor fi atașate, iar datele se detectează automat din PDF, DOC și imagini.': 'DOCX files will be attached, while data is extracted automatically from PDF, DOC, and image files.',
  'Eroare la importul documentului.': 'Error importing the document.',
  'Eroare la importul avizului.': 'Error importing the delivery note.',
  'EROARE AUTENTIFICARE': 'AUTHENTICATION ERROR',
  'adăugat manual': 'added manually',
  'Alege modul de tarifare': 'Choose the pricing method',
  'Mai multi clienti pe acelasi transport': 'Multiple customers on the same transport',
  'Email expeditor:': 'Sender email:',
  'Schimbă documentul': 'Change document',
  'Niciun șofer nu corespunde căutării': 'No drivers match your search',
  'Nu există șoferi disponibili pentru perioada transportului': 'No drivers are available during the transport period',
  'Nu există șoferi înregistrați': 'No registered drivers',
  'planificată': 'scheduled',
  'Niciun camion nu corespunde căutării': 'No trucks match your search',
  'Nicio remorcă nu corespunde căutării': 'No trailers match your search',
  'Remorcă externă': 'External trailer',
  'Adaugă încărcări și descărcări în ordinea reală. Data și ora sunt obligatorii pentru acest transport.': 'Add pick-ups and deliveries in the actual route order. A date and time are required for this transport.',
  'Adaugă opțional încărcări și descărcări în ordinea reală a traseului.': 'Optionally add pick-ups and deliveries in the actual route order.',
  'EMAIL EXPEDITOR': 'SENDER EMAIL',
  'expeditor@example.com': 'sender@example.com',
  'OPȚIONAL': 'OPTIONAL',
  'Profitabilitatea este activă pentru acest transport internațional cu flotă proprie. Adaugă țările în ordine.': 'Profitability is enabled for this international transport using the company fleet. Add the countries in order.',
  'Poți adăuga țările prin care transportul trece, dar câmpul nu este obligatoriu pentru acest transport.': 'You can add the countries crossed by the transport, but this field is optional.',
  'Vânzare către client *': 'Sale to customer *',
  'Șofer extern': 'External driver',
  'Număr camion extern': 'External truck registration number',
  'NUME EXPEDITOR': 'SENDER NAME',
  'Loc livrare pentru acest CMR': 'Delivery location for this CMR',
  'Creează prin casa de expediție': 'Create through freight forwarding',
  'Salvează partenerul': 'Save partner',
  'Documentul încărcat a fost citit și atașat transportului.': 'The uploaded document was processed and attached to the transport.',
  'Documentul original se atașează transportului.': 'The original document is being attached to the transport.',
  'Datele au fost preluate din avizul PDF. Verificați și corectați ce este necesar, apoi salvați.': 'The details were extracted from the PDF delivery note. Review and correct them as needed, then save.',
  'Completați doar câmpurile lipsă. Puteți salva un draft și reveni ulterior.': 'Complete only the missing fields. You can save a draft and return later.',

  // Temporary external access
  'Introduceți codul pentru a continua': 'Enter the code to continue',
  'Introduceți codul': 'Enter the code',
  'SE VERIFICĂ...': 'CHECKING...',
  'VERIFICĂ CODUL': 'CHECK CODE',
  'Eroare acces temporar': 'Temporary Access Error',
  'Nu am putut valida acest cod. Încearcă din nou sau contactează expeditorul.': 'We could not validate this code. Try again or contact the sender.',
  'Se încarcă informațiile de transport...': 'Loading transport information...',
  'Nu am putut încărca detaliile transportului pentru acest cod.': 'Could not load the transport details for this code.',

  // Freight-forwarding partners
  'Clienți casă de expediție': 'Freight Forwarding Customers',
  'Partenerii externi care execută transporturile intermediate.': 'External partners that fulfil brokered transports.',
  'Nu s-au putut încărca partenerii.': 'Could not load the partners.',
  'Nu am putut verifica accesul la casa de expediție.': 'Could not verify access to freight forwarding.',
  'Țara trebuie introdusă ca un cod de două litere.': 'The country must be entered as a two-letter code.',
  'Această pagină este disponibilă numai administratorilor și dispecerilor.': 'This page is available only to administrators and dispatchers.',
  'Caută după nume, CIF sau date de contact': 'Search by name, tax ID, or contact details',
  'Parteneri activi': 'Active partners',
  'Se încarcă partenerii...': 'Loading partners...',

  // CMR review screen
  'Se încarcă documentul CMR...': 'Loading the CMR document...',
  'Nu s-au putut încărca datele transportului:': 'Could not load the transport details:',
  'Nu există semnături înregistrate pentru acest CMR încă. Continuați procesarea documentului sau trimiteți-l la semnat când este gata.': 'No signatures have been recorded for this CMR yet. Continue processing the document or send it for signature when it is ready.',
  'Status Semnături Electronice': 'Electronic Signature Status',

  // Route calculation
  'Sunt necesare cel puțin 2 puncte pentru calcularea rutei': 'At least two points are required to calculate the route',
  'Ruta a fost calculată și salvată cu succes!': 'The route was calculated and saved successfully!',
  'Eroare la calcularea rutei:': 'Error calculating the route:',
  'Optimizare traseu cu PTV': 'Route Optimisation with PTV',
  'Eroare la calculare': 'Calculation error',
  'Rută salvată încărcată': 'Saved route loaded',
  'Rută calculată și salvată!': 'Route calculated and saved!',
  'Rută calculată cu succes!': 'Route calculated successfully!',

  // Transport quotations
  'Verifică detaliile traseului.': 'Check the route details.',
  'Se recalculează...': 'Recalculating...',
  'Recalculează și salvează': 'Recalculate and Save',
  'Cost de bază': 'Base cost',
  'Rezervă': 'Contingency',
  'Cost cu rezervă': 'Cost with contingency',
  'Tip cotație': 'Quotation type',
  'Loc încărcare': 'Pick-up location',
  'Loc descărcare': 'Delivery location',
  'Ora încărcării': 'Pick-up time',
  'Data descărcării': 'Delivery date',
  'Informativ; nu modifică prețul.': 'For information only; does not change the price.',
  'Media șoferilor': 'Driver averages',
  'Restricție tunel': 'Tunnel restriction',
  'Dacă nu completezi, se folosește durata rutei.': 'If left blank, the route duration is used.',
  'Durata rutei': 'Route duration',
  'Marjă comercială': 'Commercial margin',
  'Nu există o valoare implicită; poți introduce una pentru acest calcul.': 'There is no default value; you can enter one for this calculation.',
  'Cotație transport': 'Transport Quotation',
  'Exportă PDF': 'Export PDF',
  'Se generează PDF-ul...': 'Generating PDF...',
  'PDF-ul cotației nu a putut fi generat. Încearcă din nou.': 'The quotation PDF could not be generated. Try again.',
  'Destinație': 'Destination',
  'Timp total traseu': 'Total Route Time',
  'Raport financiar': 'Financial Report',
  'Resurse folosite la calcul': 'Resources Used in the Calculation',
  'Media companiei': 'Company Average',
  'Rută camion pe hartă': 'Truck Route on the Map',
  'Traseul PTV folosit la calcularea distanței și a taxelor.': 'The PTV route used to calculate distance and tolls.',
  'Afișează ruta': 'Show Route',
  'Harta rutei PTV pentru camion': 'PTV Truck Route Map',
  'Se încarcă ruta de camion...': 'Loading the Truck Route...',
  'Reîncearcă încărcarea rutei': 'Retry Route Loading',
  'Ruta de camion nu mai poate fi încărcată. Ruta PTV poate fi expirată sau planificarea rutelor nu este activă pentru companie.': 'The truck route can no longer be loaded. The PTV route may have expired or route planning may not be enabled for the company.',
  'Geometria este ruta PTV calculată cu profilul de camion al cotației. Google Maps este folosit doar pentru afișarea hărții.': 'The geometry is the PTV route calculated with the quotation truck profile. Google Maps is used only to display the map.',
  'Locație validată': 'Validated location',
  'Nu am găsit locații pentru textul introdus.': 'No locations were found for the entered text.',
  'Căutarea locațiilor nu este disponibilă momentan. Încearcă din nou mai târziu.': 'Location search is currently unavailable. Try again later.',
  'Sunt prea multe căutări în acest moment. Așteaptă puțin și încearcă din nou.': 'There are too many searches right now. Wait a moment and try again.',
  'Locația nu a putut fi căutată. Modifică textul și încearcă din nou.': 'The location could not be searched. Edit the text and try again.',
  'Căutarea locațiilor este temporar indisponibilă. Încearcă din nou.': 'Location search is temporarily unavailable. Try again.',
  'Căutarea locațiilor nu este disponibilă momentan.': 'Location search is currently unavailable.',
  'Serviciul de locații se încarcă. Încearcă din nou.': 'The location service is loading. Try again.',
  'Nu am putut obține coordonatele acestei locații. Alege o altă sugestie.': 'The coordinates for this location could not be retrieved. Choose another suggestion.',
  'Locația selectată nu are informațiile necesare. Alege o altă sugestie.': 'The selected location does not have the required information. Choose another suggestion.',
  'Selectează o locație din rezultate.': 'Select a location from the results.',
  'Locația selectată nu are un nume pentru afișare.': 'The selected location does not have a display name.',
  'Denumirea locației poate avea maximum 255 de caractere.': 'The location name can contain up to 255 characters.',
  'Caută locația de încărcare': 'Search for the pick-up location',
  'Caută locația de descărcare': 'Search for the delivery location',
  'Ruta selectată nu a putut fi calculată. Verifică locațiile și restricțiile transportului.': 'The selected route could not be calculated. Check the locations and transport restrictions.',
  'Configurare esențială': 'Essential Configuration',
  'Aceste valori sunt necesare pentru orice calcul de cotație.': 'These values are required for every quotation calculation.',
  'Țara de bază': 'Home country',
  'Cost administrativ/cotație': 'Administrative cost per quotation',
  'Pot fi suprascrise pentru fiecare cotație.': 'These values can be overridden for each quotation.',
  'Folosită când nu este selectat un camion cu profil complet.': 'Used when no truck with a complete profile is selected.',
  'Asigurare cargo lunară': 'Monthly cargo insurance',
  'Folosită când nu este selectată o remorcă cu profil complet.': 'Used when no trailer with a complete profile is selected.',
  'Media șoferului': 'Driver Average',
  'Folosită când nu este selectat un șofer cu profil complet.': 'Used when no driver with a complete profile is selected.',
  'Salariu lunar': 'Monthly salary',
  'Diurnă internațională': 'International per diem',
  'Introdu o valoare numerică validă, fără separatori de mii.': 'Enter a valid numeric value without thousands separators.',
  'Valoarea nu poate fi negativă.': 'The value cannot be negative.',
  'Selectează profilul': 'Select a profile',
  'Configurare cotații': 'Quotation Configuration',
  'Valorile sunt salvate pentru compania curentă și folosite la calculele următoare.': 'Values are saved for the current company and used in subsequent calculations.',
  'Închide configurarea': 'Close configuration',
  'Camion cu semiremorcă': 'Truck with Semitrailer',
  'Configurație vehicul pentru rutare': 'Vehicle Configuration for Routing',
  'Configurație pentru rutare': 'Routing Configuration',
  'Alege configurația de vehicul folosită la estimarea distanței, duratei și taxelor de drum.': 'Choose the vehicle configuration used to estimate distance, duration, and road tolls.',
  'Câmpurile marcate cu * sunt obligatorii pentru orice rută. Celelalte valori sunt folosite ca medii numai atunci când nu alegi o resursă configurată; câmpurile goale se salvează ca neconfigurate, nu ca zero.': 'Fields marked with * are required for every route. Other values are used as averages only when no configured resource is selected; empty fields are saved as unconfigured, not as zero.',
  'Salvează configurarea': 'Save Configuration',

  // Transport list and UIT management
  'Transportul a fost finalizat. Sincronizarea AROBS rulează în fundal și valorile se vor actualiza automat.': 'The transport has been completed. AROBS synchronisation is running in the background and the values will update automatically.',
  '✅ Document încărcat cu succes!': '✅ Document uploaded successfully!',
  'date disponibile în răspuns.': 'available data fields in the response.',
  'ℹ️ Nu există fotografie CMR pentru acest transport.': 'ℹ️ There is no CMR photo for this transport.',
  'Eroare la încărcarea fotografiei CMR. Vă rugăm încercați din nou.': 'Error loading the CMR photo. Please try again.',
  'Filtrare Transporturi': 'Filter Transports',
  'Toate transporturile': 'All transports',
  'Doar nefinalizate': 'Unfinished only',
  'Doar finalizate': 'Completed only',
  'Vizualizare rapidă': 'Quick view',
  'Starea finalizării': 'Completion status',
  'Sunt afișate atât transporturile active, cât și cele din istoric.': 'Both active and historical transports are shown.',
  'Sunt afișate doar transporturile care nu au fost încă finalizate.': 'Only transports that have not yet been completed are shown.',
  'Sunt afișate doar transporturile finalizate din istoric.': 'Only completed transports from the history are shown.',
  'Filtrează transporturile după starea finalizării': 'Filter transports by completion status',
  'Flotă și intermediere': 'Fleet and brokerage',
  'Nu există transporturi': 'No transports',
  'Nu au fost găsite transporturi care să corespundă criteriilor de căutare.': 'No transports match the search criteria.',
  'Nu au fost găsite transporturi înregistrate în sistem.': 'No registered transports were found in the system.',
  'Se finalizează': 'Completing',
  'Documentul nu poate fi afișat. Verifică URL-ul sau deschide-l în tab nou.': 'The document cannot be displayed. Check the URL or open it in a new tab.',
  'Detalii UIT': 'UIT Details',
  'Valoare totală': 'Total value',
  'Introduceți CIF-ul companiei pentru verificarea codurilor UIT.': 'Enter the company tax ID to check UIT codes.',
  'Nu am putut încărca datele UIT. Încercați din nou.': 'Could not load the UIT data. Please try again.',
  'Zile active': 'Active days',
  'Vehicule cu UIT': 'Vehicles with UIT',
  'numărul căutat': 'the searched registration number',
  'Vezi detalii ANAF': 'View ANAF details',

  // Residual delivery-note interface copy found by the runtime identity audit.
  // Values entered into the delivery note remain outside this compatibility map.
  'Creare Aviz Nou': 'Create New Delivery Note',
  'Completare:': 'Completion:',
  'Date Generale': 'General Information',
  'Bunuri': 'Goods',
  'Seria *': 'Series *',
  'Ex: AB': 'E.g. AB',
  'Ex: 001234': 'E.g. 001234',
  'Data Emiterii *': 'Issue Date *',
  'Lista Bunuri': 'Goods List',
  'Produs': 'Product',
  'Ex: Ciment': 'E.g. cement',
  'Cantitate': 'Quantity',
  'Document existent:': 'Existing document:',
  'Formatul acceptat: PDF, JPG, JPEG, PNG': 'Accepted formats: PDF, JPG, JPEG, PNG',
  'Complet': 'Complete',
  'Aproape Complet': 'Almost Complete',
  'Avize Transport': 'Transport Delivery Notes',
  'Data Emiterii:': 'Issue Date:',
  'Valoare:': 'Value:',
  'Produse:': 'Products:',
  'articole': 'items',
  'Vezi Document': 'View Document',
  'Avize pentru Transport #': 'Delivery Notes for Transport #',

  // Residual CMR form chrome. Static bilingual labels become English when the
  // interface is English; document values and uploaded content are untouched.
  'Place / Loc': 'Place',
  'Nume destinatar / Consignee name': 'Consignee name',
  'Localitate livrare / Place of delivery': 'Place of delivery',
  'Denumire transportator / Carrier name': 'Carrier name',
  'Echipaj / Crew': 'Crew',
  'Transportatori succesivi / Successive carriers': 'Successive carriers',
  'Daune / nereguli la livrare / Delivery damages': 'Delivery damage / irregularities',
  'Nr. colete / Packages': 'Packages',
  'Mod ambalare / Packing method': 'Packing method',
  'Nr. statistic / Statistical number': 'Statistical number',
  'Timestamp / Marcaj timp': 'Timestamp',
  'Arrival / Sosire': 'Arrival',
  'Departure / Plecare': 'Departure',
  'LEI / RON': 'RON',
  'Rambursare / Reimbursement': 'Reimbursement',
  'Digital document generated / Document digital generat:': 'Digital document generated:',
  'Progres completare': 'Completion Progress',
  'NUME': 'NAME',
  'DESTINATAR': 'CONSIGNEE',
  'Nume destinatar': 'Consignee name',
  'LOC LIVRARE': 'DELIVERY LOCATION',
  'Loc de livrare': 'Delivery location',
  'MOD AMBALARE': 'PACKAGING METHOD',
  'Mod ambalare': 'Packaging method',
  'NR. STATIC': 'STATISTICAL NO.',
  'Nr. static': 'Statistical no.',
  'CUBAJ (m³)': 'VOLUME (m³)',
  'Cubaj': 'Volume',
  'REDUCERI': 'DISCOUNTS',
  'Reduceri': 'Discounts',
  'SOLD': 'BALANCE',
  'Sold': 'Balance',
  'SUPLIMENTE': 'SURCHARGES',
  'Suplimente': 'Surcharges',
  'ALTE CHELTUIELI': 'OTHER EXPENSES',
  'Alte cheltuieli': 'Other expenses',
  'DATA EMITERE': 'ISSUE DATE',
  'TRANSPORTATOR': 'CARRIER',
  'TRANSPORTATORI SUCCESIVI': 'SUCCESSIVE CARRIERS',
  'Transportatori succesivi': 'Successive carriers',
  'DAUNE / NEREGULI LIVRARE': 'DELIVERY DAMAGE / IRREGULARITIES',
  'Daune / nereguli la livrare': 'Delivery damage / irregularities',
  'RAMBURSARE': 'REIMBURSEMENT',
  'Rambursare': 'Reimbursement',
  'Sumar Formular': 'Form Summary',
  'Nr. CMR': 'CMR No.',
  'Data emitere': 'Issue date',
  'Loc livrare *': 'Delivery location *',

  // CMR management, signatures and external-access interface.
  'CMR Complet': 'Complete CMR',
  'Doar Digital': 'Digital Only',
  'Doar Fizic': 'Physical Only',
  'CMR Digital': 'Digital CMR',
  'CMR-uri Fizice (': 'Physical CMRs (',
  'Deschide PDF': 'Open PDF',
  'Rezumat': 'Summary',
  'CMR-uri Fizice': 'Physical CMRs',
  'Total Documente': 'Total Documents',
  'Previzualizare CMR': 'CMR Preview',
  'Imaginea': 'Image',
  'Semnatari actuali': 'Current Signatories',
  'Nume nespecificat': 'Name not specified',
  'Semnat': 'Signed',
  'Semnat:': 'Signed:',
  'Creat:': 'Created:',
  '✅ Complet': '✅ Complete',
  'Doar CMR digital completat': 'Only the digital CMR is complete',
  '📄 Fizic': '📄 Physical',
  'Doar CMR-uri fizice (scanate)': 'Physical CMRs only (scanned)',
  'Nu are niciun CMR': 'No CMR available',
  'Fizic:': 'Physical:',
  'Generat din CMR': 'Generated from CMR',
  'Semnatar': 'Signatory',
  'Alt semnatar': 'Other Signatory',
  'Personalizare Email': 'Customise Email',
  'Subiect email': 'Email subject',
  'Mesaj personalizat': 'Custom message',
  'Semnatarii vor primi un email cu link-ul de semnare': 'Signatories will receive an email with the signing link',
  'Semnatari (': 'Signatories (',
  'Cod temporar:': 'Temporary code:',
  'Document salvat cu succes!': 'Document saved successfully!',
  'Creat de:': 'Created by:',
  'Rol:': 'Role:',
  'Link copiat!': 'Link copied!',
  'Previzualizare': 'Preview',
  'CMR Fizic 1': 'Physical CMR 1',
  'CMR-uri': 'CMRs',
  'Nivel completare CMR': 'CMR Completion Level',
  'Completare': 'Completion',
  'Doar scanat': 'Scanned Only',
  'Incomplet': 'Incomplete',
  'CMR creat cu succes!': 'CMR created successfully!',
  'Nu am putut crea CMR-ul.': 'Could not create the CMR.',
  'Creare CMR': 'Create CMR',
  'Vezi document': 'View document',

  // External CMR viewer and review workflow chrome.
  'Datele destinatarului.': 'Consignee details.',
  'Volum (m³)': 'Volume (m³)',
  'Documente anexate': 'Attached documents',
  'Rambursare (RON/EUR)': 'Reimbursement (RON/EUR)',
  'Datele companiei de transport.': 'Carrier details.',
  'Nr. membri echipaj': 'No. of crew members',
  'Sporuri': 'Surcharges',
  'Accesorii': 'Ancillary charges',
  'Diverse': 'Miscellaneous',
  'Starea documentului.': 'Document status.',
  'Document activ': 'Active document',
  'elemente': 'items',
  'CMR-ul nu poate fi exportat momentan': 'The CMR cannot be exported at this time',
  'CMR-ul nu poate fi vizualizat momentan': 'The CMR cannot be viewed at this time',
  'Dispecer': 'Dispatcher',
  'Creat la': 'Created at',
  'Acces:': 'Access:',
  'Cod:': 'Code:',
  'finalizat': 'completed',
  'Transport Finalizat cu Succes!': 'Transport Completed Successfully!',
  'Transportul #': 'Transport #',
  'a fost finalizat cu succes.': 'was completed successfully.',
  'destinatar': 'consignee',
  'Finalizat la:': 'Completed at:',
  'Companie / dispecer': 'Company / dispatcher',
  'Cererile de semnare': 'Signing requests',
  'Link semnare': 'Signing link',
  'Document semnat': 'Signed document',
  'Semnat: –': 'Signed: –',
  'CMR semnat': 'Signed CMR',
  'Control acces': 'Access control',
  'Mail nesetat': 'Email not set',
  'Format invalid': 'Invalid format',
  'Mailuri setate': 'Emails set',
  'Generez PDF...': 'Generating PDF...',
  'Salvez pe server...': 'Saving to server...',
  'Trimit...': 'Sending...',
  'Document CMR #': 'CMR Document #',
  'Transport International -': 'International Transport –',
  'Gata pentru export': 'Ready for export',
  'Nesetat': 'Not set',
  'Setat': 'Set',
  'Email Destinatar:': 'Consignee Email:',
  'Crew / Echipaj:': 'Crew:',
  'Damages / irregularities at delivery / Daune / nereguli la livrare:': 'Damage / irregularities at delivery:',
  'UIT code / Cod UIT:': 'UIT code:',
  'Email-ul pentru': 'Email for',
  'Adresa de email': 'Email address',

  // Residual transport cards, details, documents, crew and stop editor copy.
  'CMR (Fotografie)': 'CMR (Photo)',
  'Certificat de origine': 'Certificate of Origin',
  'CMR - Fotografie': 'CMR – Photo',
  'Neatribuit': 'Unassigned',
  'Atribuit': 'Assigned',
  'Nepornit': 'Not Started',
  'model necunoscut': 'unknown model',
  'Email Destinatar': 'Consignee Email',
  'Ex: CMD-2024-001': 'E.g. CMD-2024-001',
  'Profitabilitate': 'Profitability',
  'Sync km Arobs': 'Sync AROBS km',
  'Cheltuieli': 'Expenses',
  'Km Arobs': 'AROBS km',
  'Km final': 'Final km',
  'Ultima sincronizare': 'Last synchronisation',
  'Consum Arobs': 'AROBS fuel consumption',
  'Medie Arobs': 'AROBS average',
  'Km manual': 'Manual km',
  'Combustibil manual litri': 'Manual fuel (litres)',
  'Combustibil manual EUR': 'Manual fuel (EUR)',
  'Note profitabilitate': 'Profitability notes',
  'Obligatoriu': 'Required',
  'Vezi CMR': 'View CMR',
  'Comercializare': 'Commercial transaction',
  'Echipament comercial': 'Commercial equipment',
  'Mijloace fixe': 'Fixed assets',
  'Consum propriu': 'Own consumption',
  'Livrare cu instalare': 'Delivery with installation',
  'Litru': 'Litre',
  'Metru': 'Metre',
  'Niciun rezultat.': 'No results.',
  'ex: RO12345678': 'e.g. RO12345678',
  'Bunuri transportate': 'Goods transported',
  'Bun #': 'Item #',
  'Cod tarifar': 'Tariff code',
  'Ref. declarant': 'Declarant reference',
  'Autocompletat din transport': 'Auto-filled from transport',
  'Cod organizator': 'Organiser code',
  'Denumire organizator': 'Organiser name',
  'Localitate': 'Locality',
  'Cod partener': 'Partner code',
  'Denumire partener': 'Partner name',
  'Ce trebuie corectat:': 'What needs to be corrected:',
  'Cod UIT generat:': 'Generated UIT code:',
  'Titlu document (obligatoriu)': 'Document title (required)',
  'Proces Verbal': 'Handover Report',
  'Descriere (obligatoriu)': 'Description (required)',
  'Ex: Ion Popescu': 'E.g. Ion Popescu',
  'Generez...': 'Generating...',
  'Marfuri': 'Goods',
  'Consum specific (l/100km)': 'Specific consumption (l/100 km)',
  'Trasee': 'Routes',
  'Linia': 'Row',
  'Plecare loc': 'Departure place',
  'Plecare ora': 'Departure time',
  'Sosire loc': 'Arrival place',
  'Sosire ora': 'Arrival time',
  'NR act insotire': 'ACCOMPANYING DOCUMENT NO.',
  'Sumar auto': 'Vehicle summary',
  'lei': 'RON',
  'Pentru transporturile cu grupaj, profitabilitatea foloseste suma componentelor.': 'For consolidated transports, profitability uses the sum of the component loads.',
  'ml': 'lm',
  'Total grupaj:': 'Consolidated total:',
  'Descarcare': 'Unloading',
  'Metri': 'Metres',
  'Paleti': 'Pallets',
  'Volum': 'Volume',
  'Pret net': 'Net price',
  'Actiuni': 'Actions',
  'Metri podea *': 'Loading metres *',
  'ID intern #': 'Internal ID #',
  'Nr. transport': 'Transport No.',
  'Nu este disponibil': 'Not available',
  'Transport activ:': 'Active transport:',
  'Checklist transport': 'Transport Checklist',
  'Documente trimise': 'Documents sent',
  'Echipaj': 'Crew',
  'Mod transport': 'Transport mode',
  'Schimbare echipaj': 'Crew change',
  'Date reconstruite': 'Reconstructed data',
  '· Participare:': '· Participation:',
  'Asignat:': 'Assigned:',
  'Motivul poate avea maximum 500 de caractere.': 'The reason can contain at most 500 characters.',
  'Transportul a fost finalizat. Echipajul este acum read-only.': 'The transport has been completed. The crew is now read-only.',
  'Nu am putut actualiza echipajul.': 'Could not update the crew.',
  'Echipaj curent': 'Current crew',
  'Motiv *': 'Reason *',
  'Validat': 'Validated',
  'Confirmat': 'Confirmed',
  'Avize': 'Delivery Notes',
  'Cod UIT:': 'UIT code:',
  'Nr. transport intern': 'Internal transport No.',
  'Contacte comerciale istorice': 'Historical Commercial Contacts',
  'Planificat': 'Scheduled',
  'Ajuns': 'Arrived',
  'Documentele au fost trimise pentru semnare': 'The documents were sent for signature',
  'Vezi CMR Digital': 'View Digital CMR',
  'CMR Nou': 'New CMR',
  'Vezi CMR Fizic': 'View Physical CMR',
  'Probleme raportate pentru Transport #': 'Issues Reported for Transport #',
  'Deschide fotografia': 'Open photo',
  'Transport creat': 'Transport created',
  'Transport finalizat': 'Transport completed',
  'Regenerare UIT': 'Regenerate UIT',
  'Se deschide...': 'Opening...',
  'Vezi CMR Semnat': 'View Signed CMR',
  'Loc plecare:': 'Departure:',
  'Planificat:': 'Scheduled:',
  'Transport Activ': 'Active Transport',
  'Gata de Start': 'Ready to Start',
  'Destinatar:': 'Consignee:',
  'Bonuri transport #': 'Transport Receipts #',
  'bon': 'receipt',
  'bonuri': 'receipts',
  'Deschide bon': 'Open receipt',
  'Ex: Cluj, Str. Fabricii 10': 'E.g. Cluj, Str. Fabricii 10',
  'Ora': 'Time',
  'Opririle au fost actualizate.': 'Stops were updated.',
  'Tipurile opririlor au fost corectate.': 'Stop types were corrected.',
  'opriri': 'stops',
  'oprire': 'stop',
  '↑ Sus': '↑ Up',
  '↓ Jos': '↓ Down',
  'Blocat': 'Blocked',
  'Transport Creat cu Succes': 'Transport Created Successfully',
  'Transportul a fost creat': 'The transport was created',
  'Transportul a fost finalizat.': 'The transport was completed.',
  'Document CMR disponibil': 'CMR document available',
  'ID intern: #': 'Internal ID: #',
  'Transporturile mele': 'My Transports',
  'Nefinalizate': 'Not Completed',
  'Transporturi afișate': 'Displayed transports',
  'Doar ale mele': 'Only mine',
  'Alege dacă vezi toate transporturile sau doar transporturile atribuite ție': 'Choose whether to view all transports or only those assigned to you',
  'Alege dacă vizualizezi toate transporturile accesibile sau doar pe cele atribuite ție.': 'Choose whether to view all available transports or only those assigned to you.',
  'Filtrează după statusul transportului': 'Filter by transport status',
  'Filtrează după șofer': 'Filter by driver',
  'Vizualizare rapidă': 'Quick view',
  'Starea finalizării': 'Completion status',
  'Doar nefinalizate': 'Unfinished only',
  'Doar finalizate': 'Completed only',
  'Sunt afișate atât transporturile active, cât și cele din istoric.': 'Both active transports and transport history are shown.',
  'Sunt afișate doar transporturile care nu au fost încă finalizate.': 'Only transports that have not been completed are shown.',
  'Sunt afișate doar transporturile finalizate din istoric.': 'Only completed transports from the history are shown.',
  'Filtrează transporturile după starea finalizării': 'Filter transports by completion status',
  'Mod executare': 'Execution Mode',
  'Executate intern': 'Handled Internally',
  'Finalizare': 'Completion',
  '— nespecificat': '— not specified',
  'Date comerciale': 'Commercial Details',
  'Vezi (': 'View (',
  'Bonuri': 'Receipts',
  'Regenerare': 'Regenerate',
  'Previzualizare document': 'Document Preview',

  // Transport quotation and transport-profitability residual copy.
  'Taxele de drum sunt estimate.': 'Road tolls are estimated.',
  'Clasificare': 'Classification',
  'Defalcarea costurilor': 'Cost Breakdown',
  '— indisponibil pentru calcul': '— unavailable for calculation',
  'Transport dedicat': 'Dedicated Transport',
  'Configurare': 'Configuration',
  'Reia calculul': 'Resume Calculation',
  'Lipsesc:': 'Missing:',
  'Metri podea': 'Loading metres',
  'Ex. 13,60': 'E.g. 13.60',
  'Media camioanelor': 'Truck Fleet Average',
  'Media remorcilor': 'Trailer Fleet Average',
  'Materiale periculoase': 'Hazardous Materials',
  'Ore frigorific': 'Refrigeration Hours',
  'Cost suplimentar (EUR)': 'Additional Cost (EUR)',
  'Implicit': 'Default',
  'Calculul nu poate porni. Lipsesc:': 'The calculation cannot start. Missing:',
  'Mai sunt': 'There are still',
  'Vezi configurarea': 'View Configuration',
  'Profil rutare PTV': 'PTV Routing Profile',
  'Procente implicite': 'Default Percentages',
  'Media camionului': 'Truck Average',
  'Consum': 'Consumption',
  'Cost lunar de utilizare': 'Monthly Operating Cost',
  'Media remorcii': 'Trailer Average',
  'Consum agregat frigorific': 'Refrigeration Unit Consumption',
  'Valoarea este prea mare.': 'The value is too large.',
  'Necesar acum': 'Required Now',
  'Neconfigurat': 'Not Configured',
  'Calculat': 'Calculated',
  'Nu am putut genera cursele tur-retur.': 'Could not generate the round trips.',
  'Sincronizarea AROBS nu s-a putut programa.': 'AROBS synchronisation could not be scheduled.',
  'Nu am putut salva totalurile lunii.': 'Could not save the monthly totals.',
  'Raport lunar tur-retur': 'Monthly Round-Trip Report',
  'Cheltuieli variabile': 'Variable Expenses',
  'Diurne configurate': 'Configured Per Diems',
  'Costuri fixe automate': 'Automatic Fixed Costs',
  'Datele grupului': 'Group Details',
  'Valori pe transport': 'Per-Transport Values',
  'Profit net companie ·': 'Company Net Profit ·',
  'Combustibil detectat': 'Detected Fuel',
  'linii': 'lines',
  'Taxe drum detectate': 'Detected Road Tolls',
  'se pot aplica automat': 'can be applied automatically',
  'linii combustibil care mai trebuie corectate': 'fuel lines that still need correction',
  'EUR selectat implicit': 'EUR selected by default',
  'Litri': 'Litres',
  'Valoare EUR': 'EUR Value',
  'Preview taxe drum': 'Road Toll Preview',
  'Nu s-au detectat taxe de drum.': 'No road tolls were detected.',
  'Dreapta →': 'Right →',
  'Scroll dreapta': 'Scroll right',
  'Tabel curse tur-retur': 'Round-Trip Table',
  'Resurse': 'Resources',
  'Alte costuri': 'Other Costs',
  'Costuri fixe companie': 'Company Fixed Costs',
  'Profit net companie': 'Company Net Profit',
  'Respinge': 'Reject',
  'Se respinge…': 'Rejecting…',
  'Consum:': 'Consumption:',
  'Medie:': 'Average:',
  'Comb.': 'Fuel',
  'Taxe': 'Tolls',
  'Interv.': 'Interventions',
  'La totalul lunii': 'In the Monthly Total',
  'Calculat din componentele grupajului': 'Calculated from consolidated-load items',
  'Curs': 'Exchange Rate',
  'Taxe drum (EUR)': 'Road Tolls (EUR)',
  'Alte costuri existente': 'Other Existing Costs',
  'Profit estimat': 'Estimated Profit',
  'Detaliere costuri fixe automate': 'Automatic Fixed Cost Breakdown',
  'incluse': 'included',
  'Procentaj automat dispeceri': 'Automatic Dispatcher Percentage',
  'Restricții raportate pe rută': 'Restrictions Reported on the Route',
  'Sunt afișate primele 20 de restricții raportate.': 'The first 20 reported restrictions are shown.',
  'Atenționări de calcul': 'Calculation Warnings',
  'Motorină:': 'Diesel:',
  'Medie săptămânală, date din': 'Weekly average, data from',
  'ultima actualizare disponibilă': 'latest available update',
  'Se calculează ruta și costurile transportului...': 'Calculating the route and transport costs...',
  'Calculul este în curs. Te rugăm să aștepți câteva momente...': 'The calculation is in progress. Please wait a few moments...',
  'Setări companie': 'Company Settings',
  'Tipuri și resurse': 'Types and Resources',
  'Se folosește ultima medie săptămânală disponibilă; implicit România.': 'Uses the latest available weekly average; Romania is selected by default.',
  'Țara prețului motorinei': 'Diesel Price Country',
  'Tipul de cotație a fost actualizat.': 'The quotation type was updated.',
  'Tipul de cotație a fost creat.': 'The quotation type was created.',
  'Regulile formularului sunt generate din aceste setări.': 'The form rules are generated from these settings.',
  'Tipuri de cotație': 'Quotation Types',
  'Adaugă tip de cotație': 'Add Quotation Type',
  'activ': 'active',
  'inactiv': 'inactive',
  'Nu există tipuri configurate.': 'No quotation types are configured.',
  'Codul devine permanent după creare.': 'The code becomes permanent after creation.',
  'Editează tipul': 'Edit Type',
  'Tip nou': 'New Type',
  'Cod tip': 'Type Code',
  'Codul nu poate fi schimbat ulterior.': 'The code cannot be changed later.',
  'Ex.: express, frigorific, adr': 'E.g. express, refrigerated, adr',
  'Denumire': 'Name',
  'Lasă necompletat pentru valoarea companiei.': 'Leave blank to use the company value.',
  'Rezervă implicită (%)': 'Default Reserve (%)',
  'Marjă comercială implicită (%)': 'Default Commercial Margin (%)',
  'Ordine de afișare': 'Display Order',
  'Disponibil pentru cotații noi': 'Available for New Quotations',
  'Necesită ADR': 'Requires ADR',
  'Necesită transport frigorific': 'Requires Refrigerated Transport',
  'Profilul de cost și capabilități a fost salvat.': 'The cost and capability profile was saved.',
  'Profilul a fost șters. Resursa va folosi mediile companiei.': 'The profile was deleted. The resource will use company averages.',
  'Completează costurile proprii și capabilitățile folosite de calculator.': 'Configure the costs and capabilities used by the calculator.',
  'Profiluri de resurse': 'Resource Profiles',
  'Resursă': 'Resource',
  'Selectează resursa': 'Select a Resource',
  'Profil complet pentru calcul.': 'Profile complete for calculation.',
  'Profil incomplet: valorile de cost lipsă vor folosi mediile companiei.': 'Incomplete profile: missing cost values will use company averages.',
  'Confirmi ștergerea?': 'Confirm deletion?',
  'Salvează profilul': 'Save Profile',
  'Șterge profilul': 'Delete Profile',
  'Diurna lunară a șoferului a fost salvată.': 'The driver monthly per diem was saved.',
  'Diurna lunară a fost eliminată.': 'The monthly per diem was removed.',
  'Configurează suma și numărul de zile separat pentru fiecare șofer și lună.': 'Configure the amount and number of days separately for each driver and month.',
  'Configurează suma și numărul de zile separat pentru fiecare șofer și lună. Modificările sunt comune cu evidența lunară și pot afecta rapoartele viitoare.': 'Configure the amount and number of days separately for each driver and month. Changes are shared with monthly records and may affect future reports.',
  'Camionul selectat nu este compatibil cu ADR.': 'The selected truck is not ADR-compatible.',
  'Camionul selectat nu este compatibil cu transport frigorific.': 'The selected truck is not compatible with refrigerated transport.',
  'Remorca selectată nu este compatibilă cu ADR.': 'The selected trailer is not ADR-compatible.',
  'Remorca selectată nu este compatibilă cu transport frigorific.': 'The selected trailer is not compatible with refrigerated transport.',
  'Șoferul selectat nu este compatibil cu ADR.': 'The selected driver is not ADR-compatible.',
  'Șoferul selectat nu este compatibil cu transport frigorific.': 'The selected driver is not compatible with refrigerated transport.',
  'Diurne lunare': 'Monthly Per Diems',
  'Sumă zilnică': 'Daily Amount',
  'Număr de zile': 'Number of Days',
  'Conversie valutară': 'Currency Conversion',
  'Tipurile de cotație nu au putut fi încărcate. Încearcă din nou.': 'The quotation types could not be loaded. Try again.',
  'Tipul de cotație nu a putut fi salvat. Verifică valorile și încearcă din nou.': 'The quotation type could not be saved. Check the values and try again.',
  'Profilul nu a putut fi salvat. Verifică valorile și încearcă din nou.': 'The profile could not be saved. Check the values and try again.',
  'Profilul nu a putut fi șters. Încearcă din nou.': 'The profile could not be deleted. Try again.',
  'Diurna nu a putut fi încărcată. Încearcă din nou.': 'The per diem could not be loaded. Try again.',
  'Diurna nu a putut fi salvată. Verifică valorile și încearcă din nou.': 'The per diem could not be saved. Check the values and try again.',
  'Diurna nu a putut fi eliminată. Încearcă din nou.': 'The per diem could not be removed. Try again.',
  'Sumă zilnică în EUR': 'Daily Amount in EUR',
  'Total evidență lunară': 'Monthly Record Total',
  'Curs utilizat': 'Exchange Rate Used',
  'Numărul de zile aparține evidenței lunare și nu limitează zilele calculate ale unei cotații.': 'The number of days belongs to the monthly record and does not limit the days calculated for a quotation.',
  'Elimină luna': 'Remove Month',
  'Diurne șoferi': 'Driver Per Diems',
  'Profiluri resurse': 'Resource Profiles',
  'Consum frigorific': 'Refrigeration Consumption',
  'Compatibil frigorific': 'Refrigeration Compatible',
  'Valabil până la — utilizare': 'Valid Until — Operation',
  'Valabil până la — amortizare': 'Valid Until — Depreciation',
  'Valabil până la — RCA': 'Valid Until — Third-Party Liability Insurance',
  'Valabil până la — CASCO': 'Valid Until — Comprehensive Insurance',
  'Valabil până la — cargo': 'Valid Until — Cargo Insurance',
  'Valabil până la — salariu': 'Valid Until — Salary',
});

// Dynamic UI messages produced with template literals. These patterns translate
// only the interface-owned sentence and preserve interpolated business values.
export const legacyEnglishTransportPatterns = Object.freeze([
  [/^Vezi avizul încărcat: (.+)$/u, 'View uploaded delivery note: $1'],
  [/^Emis: (.+)$/u, 'Issued: $1'],
  [/^(.+) colete$/u, '$1 packages'],
  [/^Echipaj: (.+)$/u, 'Crew: $1'],
  [/^Deschide imaginea (.+)$/u, 'Open image $1'],
  [/^Semnat: (.+)$/u, 'Signed: $1'],
  [/^Document semnat #(.+)$/u, 'Signed document #$1'],
  [/^Probleme \((\d+)\)$/u, 'Issues ($1)'],
  [/^Documente \((\d+)\)$/u, 'Documents ($1)'],
  [/^· Poza (.+) din (.+)$/u, '· Photo $1 of $2'],
  [/^CMR - poza (.+)$/u, 'CMR – photo $1'],
  [/^CMR fizic (.+)$/u, 'Physical CMR $1'],
  [/^Ștergi componenta pentru acest client\?$/u, 'Delete this consolidated-load item?'],
  [/^Salvează \((\d+)\)$/u, 'Save ($1)'],
  [/^Finalizezi transportul (.+)\?$/u, 'Complete transport $1?'],
  [/^AROBS sincronizat pentru (.+): (.+) km\.$/u, 'AROBS synchronised for $1: $2 km.'],
  [/^eTransport validat(.*)$/u, 'eTransport validated$1'],
  [/^Cod UIT: (.+)\.$/u, 'UIT code: $1.'],
  [
    /^Status: (Confirmat|Validat|Respins|În prelucrare|Necunoscut)$/u,
    (_, status) => `Status: ${({
      Confirmat: 'Confirmed',
      Validat: 'Validated',
      Respins: 'Rejected',
      'În prelucrare': 'Processing',
      Necunoscut: 'Unknown',
    })[status]}`,
  ],
  [/^Sunt permise maximum (\d+) zecimale\.$/u, 'A maximum of $1 decimal places is allowed.'],
  [/^Generate: (\d+) grupuri tur-retur\.$/u, 'Generated: $1 round-trip groups.'],
  [/^(\d+) trimise la sincronizare AROBS\.$/u, '$1 sent for AROBS synchronisation.'],
  [/^· curs 1 EUR = (.+)$/u, '· rate 1 EUR = $1'],
  [/^· curs (.+)$/u, '· rate $1'],
  [/^la (\d[\s\S]*)$/u, 'at $1'],
  [/^de Utilizator #(\S+)$/u, 'by User #$1'],
  [/^de ([^\s@]+@[^\s@]+)$/u, 'by $1'],
  [/^de (\p{Lu}[\p{L}\p{M}.'’ -]+)$/u, 'by $1'],
  [/^Preț: (.+)$/u, 'Price: $1'],
  [/^Eroare la ștergere: (.+)$/u, 'Deletion error: $1'],
  [/^Eroare la salvare: (.+)$/u, 'Save error: $1'],
  [/^· Actualizată: (.+)$/u, '· Updated: $1'],
  [/^Cerere #(.+) ·$/u, 'Request #$1 ·'],
  [
    /^Caută (punct de ridicare|punct de livrare) în Europa\.\.\.$/u,
    (_, pointType) => `Search for ${pointType === 'punct de ridicare' ? 'pickup point' : 'delivery point'} in Europe...`,
  ],
  [/^Eroare la încărcarea documentului: (.+)$/u, 'Error uploading the document: $1'],
  [/^Șofer #(\S+) \(indisponibil\)$/u, 'Driver #$1 (unavailable)'],
  [/^Camion #(\S+) \(indisponibil\)$/u, 'Truck #$1 (unavailable)'],
  [/^Remorcă #(\S+) \(indisponibilă\)$/u, 'Trailer #$1 (unavailable)'],
  [/^Introduceți prețul în (.+)$/u, 'Enter the price in $1'],
  [
    /^Cererea a fost trimisă către ANAF\. ID încărcare: (.+?)\.(?: Cod UIT: (.+?)\.)? Verificați statusul pentru confirmarea finală a valabilității UIT\.$/u,
    (_, uploadId, uitCode) => `The request was submitted to ANAF. Upload ID: ${uploadId}.${uitCode ? ` UIT code: ${uitCode}.` : ''} Check the status for final confirmation of UIT validity.`,
  ],
  [
    /^Cererea a fost trimisă către ANAF\.(?: Cod UIT: (.+?)\.)? Verificați statusul pentru confirmare\.$/u,
    (_, uitCode) => `The request was submitted to ANAF.${uitCode ? ` UIT code: ${uitCode}.` : ''} Check the status for confirmation.`,
  ],
  [/^Ștergi componenta pentru (.+)\?$/u, 'Delete the consolidated-load item for $1?'],
  [/^· Comandă client (.+)$/u, '· Customer order $1'],
  [/^Șoferul (\d+)$/u, 'Driver $1'],
  [/^Șoferul (\d+): (.+)$/u, 'Driver $1: $2'],
  [/^Status vehicul \((.+)\)$/u, 'Vehicle status ($1)'],
  [/^Problemă transport (.+)$/u, 'Transport issue $1'],
  [/^Status vehicul (.+)$/u, 'Vehicle status $1'],
  [/^Oprirea (.+) nu are versiunea necesară\. Reîncarcă transportul și încearcă din nou\.$/u, 'Stop $1 does not have the required version. Reload the transport and try again.'],
  [
    /^Adaugă (încărcare|descărcare|oprire) după această oprire$/u,
    (_, stopType) => `Add ${({
      încărcare: 'loading stop',
      descărcare: 'unloading stop',
      oprire: 'stop',
    })[stopType]} after this stop`,
  ],
  [
    /^Nu am putut citi datele din acest (document|aviz)\.$/u,
    (_, documentType) => `Could not read the data from this ${documentType === 'aviz' ? 'delivery note' : 'document'}.`,
  ],
  [
    /^Eroare la citirea acestui (document|aviz)\.$/u,
    (_, documentType) => `Error reading this ${documentType === 'aviz' ? 'delivery note' : 'document'}.`,
  ],
  [/^Transportul a fost creat, dar documentul nu a putut fi atașat(.*)$/u, 'The transport was created, but the document could not be attached$1'],
  [
    /^Fișierul original a fost atașat transportului ca document Aviz\.(?: Încă (\d+) avize au fost atașate ca documente\.)?(?: CMR-uri create: (\d+)\.)?$/u,
    (_, deliveryNoteCount, cmrCount) => [
      'The original file was attached to the transport as a delivery-note document.',
      deliveryNoteCount ? `${deliveryNoteCount} additional delivery notes were attached as documents.` : '',
      cmrCount ? `${cmrCount} CMRs were created.` : '',
    ].filter(Boolean).join(' '),
  ],
  [/^Încă (\d+) avize au fost atașate ca documente\.$/u, '$1 additional delivery notes were attached as documents.'],
  [/^REÎNCEARCĂ ÎN (\d+)s$/u, 'TRY AGAIN IN $1s'],
  [
    /^(Clientul|Transportatorul) a fost adăugat\.$/u,
    (_, partner) => `The ${partner === 'Clientul' ? 'customer' : 'carrier'} was added.`,
  ],
  [/^Valoare efectivă: (.+)%$/u, 'Effective value: $1%'],
  [/^Valoarea trebuie să fie cel mult (.+)\.$/u, 'The value must be no greater than $1.'],
  [/^Valoarea trebuie să fie mai mică decât (.+)\.$/u, 'The value must be less than $1.'],
  [/^Calculul este încă în procesare\. Verificare (\d+)\/20\.\.\.$/u, 'The calculation is still processing. Check $1/20...'],
  [/^Eroare la încărcarea transportului: (.+)$/u, 'Error loading the transport: $1'],
  [
    /^✅ Document încărcat cu succes! AI a extras: (.+)$/u,
    (_, details) => `✅ Document uploaded successfully. AI extracted: ${details
      .replace(/^sumă:/u, 'amount:')
      .replace(/, monedă:/gu, ', currency:')
      .replace(/, furnizor:/gu, ', supplier:')}`,
  ],
]);
